const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/custom-fields/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { requirePermission } from '@/lib/hooks/common/usePermissions';
import { getCustomFieldsQueryOptions } from '@/lib/queries/common/useGetCustomFieldsQuery';
import i18n from '@/lib/translations/i18n';
const customFieldsSearchSchema = z.object({
  search: z.coerce.string().optional()
});
export const Route = createFileRoute('/(app)/org/$org/settings/custom-fields/')({
  validateSearch: zodValidator(customFieldsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_integrations'),
  loader: async ({
    context: {
      queryClient
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getCustomFieldsQueryOptions());
    return {
      crumb: i18n.t($ => $.common.settings.customFields.customFields)
    };
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.customFields.customFields)
    }
  }
});